import dayjs from "dayjs";

export const DATE_ONLY_FORMAT = "YYYY-MM-DD";

export type DateRangeSelection = {
  dateModified?: string;
  dateFrom?: string;
  dateTo?: string;
};

export type DateRange = {
  startDate?: string;
  endDate?: string;
};

export const getPresetDateRanges = (
  now: Date = new Date()
): Record<string, DateRange> => {
  const today = dayjs(now);
  const basePresets: Record<string, DateRange> = {
    last7Days: {
      startDate: today.subtract(7, "day").format(DATE_ONLY_FORMAT),
      endDate: today.format(DATE_ONLY_FORMAT),
    },
    last30Days: {
      startDate: today.subtract(30, "day").format(DATE_ONLY_FORMAT),
      endDate: today.format(DATE_ONLY_FORMAT),
    },
    thisYear: {
      startDate: today.startOf("year").format(DATE_ONLY_FORMAT),
      endDate: today.format(DATE_ONLY_FORMAT),
    },
    last3Years: {
      startDate: today.subtract(3, "year").startOf("day").format(DATE_ONLY_FORMAT),
      endDate: today.format(DATE_ONLY_FORMAT),
    },
  };

  return basePresets;
};

export const toUtcStartOfDay = (value?: string): string | undefined => {
  if (!value) return undefined;
  const parsed = dayjs(value, DATE_ONLY_FORMAT);
  if (!parsed.isValid()) return undefined;
  return `${parsed.format(DATE_ONLY_FORMAT)}T00:00:00Z`;
};

export const toUtcStartOfNextDay = (value?: string): string | undefined => {
  if (!value) return undefined;
  const parsed = dayjs(value, DATE_ONLY_FORMAT);
  if (!parsed.isValid()) return undefined;
  return `${parsed.add(1, "day").format(DATE_ONLY_FORMAT)}T00:00:00Z`;
};

export const isoToDateOnly = (value?: string | null): string | undefined => {
  if (!value) return undefined;
  if (value.length < 10) return undefined;
  return value.slice(0, 10);
};

export const resolveDateRange = (
  selection: DateRangeSelection,
  now: Date = new Date()
): DateRange => {
  const presets = getPresetDateRanges(now);
  const preset = selection.dateModified ? presets[selection.dateModified] : undefined;
  if (preset) {
    return preset;
  }

  if (selection.dateFrom || selection.dateTo) {
    return {
      startDate: selection.dateFrom || undefined,
      endDate: selection.dateTo || undefined,
    };
  }

  return {};
};
